import React from "react";
import {
  Flex,
  Text,
  Box,
} from "@chakra-ui/react";
import Chart from "react-apexcharts";
import Card from "components/Card/Card";
import ExportButton from "components/Reports/ExportCSV";

const ReferralLocationChart = ({
  data = [],
  loading,
}) => {
  if (loading) return null;

  const chartData = data.map((item) => ({
    district: item.district || "Unknown",
    recruits: item.drivers || 0,
  }));

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
    },

    xaxis: {
      categories: chartData.map(
        (item) => item.district
      ),
      labels: {
        rotate: -45,
        style: {
          colors: "#071D54",
          fontSize: "11px",
        },
      },
      title: {
        text: "District",
        style: {
          color: "#071D54",
        },
      },
    },

    yaxis: {
      title: {
        text: "Recruited Drivers",
        style: {
          color: "#071D54",
        },
      },
      labels: {
        style: {
          colors: "#071D54",
        },
      },
    },

    plotOptions: {
      bar: {
        borderRadius: 5,
        columnWidth: "55%",
        distributed: true,
      },
    },

    colors: [
      "#071D54",
      "#102A70",
      "#1A388C",
      "#2445A8",
      "#2D52C4",
      "#376FE0",
      "#418CFC",
      "#5AA0FF",
      "#60A5FA",
    ],

    dataLabels: {
      enabled: false,
    },

    grid: {
      show: false,
    },

    tooltip: {
      theme: "dark",
      y: {
        formatter: (value) =>
          `${value} Recruit${
            value === 1 ? "" : "s"
          }`,
      },
    },
  };

  const series = [
    {
      name: "Recruited Drivers",
      data: chartData.map(
        (item) => item.recruits
      ),
    },
  ];

  const exportData = chartData.map(
    (item) => ({
      District: item.district,
      Recruits: item.recruits,
    })
  );

  return (
    <Card
      py="1rem"
      height="400px"
      width="100%"
      bg="white"
      position="relative"
    >
      <Box
        position="absolute"
        top="12px"
        right="12px"
        zIndex="2"
      >
        <ExportButton
          data={exportData}
          fileName="recruited_driver_locations"
        />
      </Box>

      <Flex
        px={5}
        pt={2}
      >
        <Text
          color="#071D54"
          fontWeight="bold"
          fontSize="lg"
        >
          Recruited Driver Locations
        </Text>
      </Flex>

      <Chart
        options={chartOptions}
        series={series}
        type="bar"
        width="100%"
        height="320"
      />
    </Card>
  );
};

export default ReferralLocationChart;